import { default as chatBot } from './bot/services' 
import { default as systemAlertMessage } from './alert/services'

export default { 
	chatBot,
	systemAlertMessage
}
